/* eslint-disable */
import { FC, ReactNode } from 'react';
import styles from '../../styles/components/controlVariations/ConfirmDownloadModal.module.css';
import DefaultSuccessIcon from '../../assets/icons/TickMarkSuccess.png';

interface SuccessContentProps {
	title?: string;
	subtitle?: string;
	icon?: string;
	children?: ReactNode;
	className?: string;
}

const SuccessContent: FC<SuccessContentProps> = ({
	title = 'Success',
	subtitle,
	icon = DefaultSuccessIcon,
	children,
	className = '',
}) => {
	console.log('Success component');
	return (
		<div className={styles.overlay}>
			<div className={`${styles.modal} ${className}`}>
				<div className={styles.iconWrapper}>
					<img src={icon} alt="success-icon" />
				</div>

				<h2 className={styles.title}>{title}</h2>

				{subtitle && <p className={styles.subtitle}>{subtitle}</p>}

				{children}
			</div>
		</div>
	);
};

export default SuccessContent;
